import { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, Phone, Clock, TrendingUp } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function RealTimeDashboard() {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMetrics();
    const interval = setInterval(fetchMetrics, 5000); // Update every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const fetchMetrics = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/reports/real-time`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMetrics(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching real-time metrics:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-4">Loading metrics...</div>;
  }

  if (!metrics) {
    return <div className="text-center py-4 text-gray-500">No metrics available</div>;
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="bg-white rounded-lg shadow p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Agents On Call</p>
            <p className="text-2xl font-bold">{metrics.agents_on_call || 0}</p>
          </div>
          <Phone className="w-8 h-8 text-blue-600" />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Available</p>
            <p className="text-2xl font-bold">{metrics.agents_available || 0}</p>
          </div>
          <Users className="w-8 h-8 text-green-600" />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">On Break</p>
            <p className="text-2xl font-bold">{metrics.agents_on_break || 0}</p>
          </div>
          <Clock className="w-8 h-8 text-yellow-600" />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Active Calls</p>
            <p className="text-2xl font-bold">{metrics.active_calls || 0}</p>
          </div>
          <TrendingUp className="w-8 h-8 text-purple-600" />
        </div>
      </div>
    </div>
  );
}


